/*
 * Copyright (C) 2022 by attentus GmbH
 * All Rights Reserved
 * https://www.attentus.com
 * jeckplan@attentus.com
 *
 * This source code is proprietary and confidential. Unauthorized
 * copying of this file via any medium is strictly prohibited and
 * lead to legal consequences.
 *
 * @package Jeckplan
 * @author  Joachim Binnemann <binnemann@attentus.com>
 * @author  Kolja Nolte <nolte@attentus.com>
 */

/**
 * Sets the loading state of buttons.
 */
function btnLoading(elem) {
	jQuery(elem).attr('data-original-text', jQuery(elem).html());
	jQuery(elem).prop('disabled', true);
	jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Laden...');
}

/**
 * Sets the sending state of buttons.
 */
function btnSending(elem) {
	jQuery(elem).attr('data-original-text', jQuery(elem).html());
	jQuery(elem).prop('disabled', true);
	jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Senden...');
}

/**
 * Sets the saving state of buttons.
 */
function btnSaving(elem) {
	jQuery(elem).attr('data-original-text', jQuery(elem).html());
	jQuery(elem).prop('disabled', true);
	jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Speichern...');
}

/**
 * Sets the deleting state of buttons.
 */
function btnDeleting(elem) {
	jQuery(elem).attr('data-original-text', jQuery(elem).html());
	jQuery(elem).prop('disabled', true);
	jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Löschen...');
}

/**
 * Resets the state of buttons.
 */
function btnReset(elem) {
	jQuery(elem).addClass('btn-success');
	jQuery(elem).html('<i class="fa fa-check"></i> Fertig');
	jQuery(elem).prop('disabled', false);
	setTimeout(function () {
		jQuery(elem).removeClass('btn-success');
		jQuery(elem).html(jQuery(elem).attr('data-original-text'));
	}, 1000);

}

const loadingHTML = '<div id="loading-html" class="alert d-flex justify-content-center"><div class="spinner-border text-jeck-red" role="status"><span class="sr-only">Laden...</span></div></div>';

function updateProgressBar(progressBar, loaded, total, label) {
	var current       = progressBar.attr('aria-valuenow');
	var percent       = Math.floor(loaded / total * 100);
	let progressWrap  = progressBar.parents('.progress-wrap');
	let progressLabel = progressWrap.find('.progress-label');
	//console.log('current: ' + current + ', loaded: ' + loaded + ', percent: ' + percent);

	if (percent > 100) {
		percent = 100;
	}

	progressBar.text(percent + '%');
	progressBar.attr('aria-valuenow', percent);
	progressBar.css('width', percent + '%');

	if (label) {
		progressLabel.text(label);
	}

	if (percent == 0) {
		progressWrap.removeClass('d-none');
		progressBar.css('display', 'block');
	}
	if (percent == 100) {
		progressLabel.html('');
		progressBar.text('');
		setTimeout(function () {
			progressBar.fadeOut();
			progressWrap.addClass('d-none');
		}, 1000);

	}
}

function setProgressBar(progressBar, percent, label) {
	let progressWrap  = progressBar.parents('.progress-wrap');
	let progressLabel = progressWrap.find('.progress-label');
	if (percent > 100) {
		percent = 100;
	}

	progressBar.text(percent + '%');
	progressBar.attr('aria-valuenow', percent);
	progressBar.css('width', percent + '%');

	if (label) {
		progressLabel.text(label);
	}

	if (percent == 0) {
		progressWrap.removeClass('d-none');
		progressBar.css('display', 'block');
	}
	if (percent == 100) {
		progressLabel.html('');
		progressBar.text('');
		setTimeout(function () {
			progressBar.fadeOut();
			progressWrap.addClass('d-none');
		}, 1000);

	}
}

/**
 * Stores checkboxes in allTablesCheckboxes[]
 */
function storeTableCheckboxes(tableID) {
	let table           = document.getElementById(tableID);
	let tableCheckboxes = table.querySelectorAll('input[type="checkbox"]:not(.table-check-toggler)');
	if (table.classList.contains('ajax-sort-table') === false) {
		allTablesCheckboxes[tableID] = {};
	}
	for (var j = 0; j < tableCheckboxes.length; j++) {
		var box     = tableCheckboxes[j];
		var arr     = [];
		var dataset = box.dataset;
		for (var d in dataset) {
			arr[d] = dataset[d];
		}
		arr['checked']                          = box.checked;
		allTablesCheckboxes[tableID][arr['id']] = arr;
	}
	console.log('store allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
}

/**
 * Reinit functions after ajax calls/rerendering elements
 */
function reInitCheckboxes() {
	/**
	 * Toggles checkboxes in table columns
	 */
	jQuery('.table-check-toggler').click(function () {
		var tableID = jQuery(this).closest('table').attr('id');
		jQuery(this).closest('table').find('input:checkbox').prop('checked', jQuery(this).is(':checked'));
		if (allTablesCheckboxes[tableID] === undefined) {
			allTablesCheckboxes[tableID] = {};
		}
		if (allTablesCheckboxes[tableID] !== undefined) {
			if (jQuery('#' + tableID).hasClass('ajax-sort-table')) {
				storeTableCheckboxes(tableID);
			}
			for (key in allTablesCheckboxes[tableID]) {
				allTablesCheckboxes[tableID][key]['checked'] = jQuery(this).is(':checked');
			}
		}
		console.log('toggle allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
	});

	/**
	 * Stores checkboxes states in allTablesCheckboxes[]
	 */
	jQuery('table input:checkbox:not(.table-check-toggler)').on('change', function () {
		var elementID = jQuery(this).data('id');
		var tableID   = jQuery(this).closest('table').attr('id');
		if (allTablesCheckboxes[tableID] === undefined) {
			allTablesCheckboxes[tableID] = {};
			console.log('undefined allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
		}
		if (allTablesCheckboxes[tableID][elementID] === undefined) {
			var box     = jQuery(this);
			var arr     = [];
			var dataset = box.data();
			for (var d in dataset) {
				arr[d] = dataset[d];
			}
			arr['checked']                          = box.is(':checked');
			allTablesCheckboxes[tableID][arr['id']] = arr;
			console.log('undefined allTablesCheckboxes[' + tableID + '][' + elementID + ']: ', allTablesCheckboxes[tableID][elementID]);
		}
		else if (elementID !== undefined && allTablesCheckboxes[tableID] !== undefined) {
			allTablesCheckboxes[tableID][elementID]['checked'] = this.checked;
			console.log('defined allTablesCheckboxes[' + tableID + '][' + elementID + '][checked]: ', this.checked);
		}
		console.log('change allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
	});
}

/**
 * Toggles checkboxes states stored in allTablesCheckboxes[]
 */
function checkTableCheckboxes(tableID) {
	let table             = document.getElementById(tableID);
	let tableCheckToggler = table.getElementsByClassName('table-check-toggler')[0];
	if (allTablesCheckboxes[tableID] !== undefined) {
		let boxes        = table.querySelectorAll('input[type="checkbox"]:not(.table-check-toggler)');
		let checkedBoxes = 0;
		for (i = 0; i < boxes.length; ++i) {
			var boxID = boxes[i].getAttribute('data-id');
			if (allTablesCheckboxes[tableID][boxID] !== undefined) {
				boxes[i].checked = allTablesCheckboxes[tableID][boxID]['checked'];
				if (boxes[i].checked) {
					checkedBoxes++;
				}
				//console.log('boxes[' + i + '].checked: ', boxes[i].checked);
				//console.log('allTablesCheckboxes[' + tableID + '][' + boxID + ']: ', allTablesCheckboxes[tableID][boxID]);
			}
		}

		if (boxes.length === checkedBoxes) {
			tableCheckToggler.checked = true;
		}
		else {
			tableCheckToggler.checked = false;
		}
		//console.log('check allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
	}
	reInitCheckboxes();
}

jQuery(document).ready(function ($) {
	jQuery.migrateMute = true;

	Date.prototype.timestamp = function () {
		var yyyy = this.getFullYear().toString();
		var mm   = (this.getMonth() + 1).toString();
		var dd   = this.getDate().toString();
		var hh   = this.getHours().toString();
		var ii   = this.getMinutes().toString();
		var ss   = this.getSeconds().toString();
		return (dd[1] ? dd : '0' + dd[0]) + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + yyyy + '_' + hh + '-' + ii + '-' + ss;
	};

	/**
	 * Toggles the content of cards up and down.
	 */
	$('.card .card-toggler').on('click', function () {
		$(this).closest('.card').find('.card-body').slideToggle('fast');
		$(this).toggleClass('collapsed');
	});

	/**
	 * Toggles the visibility for the Childs in Member Site.
	 * TODO: Add more Childs than 4. Array? Maybe new Table in Database?
	 * TODO: Add Function with Macro in Twig?
	 */

	var currentIndex = -1;
	var elements     = ['#childWrapper_1', '#childWrapper_2', '#childWrapper_3', '#childWrapper_4'];
	for (var i = 0; i < elements.length; i++) {
		if (i == 0 && $('#child_first_name').val() || i != 0 && $('#child_first_name_' + i).val()) {
			$(elements[i]).removeClass('hidden');
		}
	}

	$('#add-child-button').click(function (e) {
		e.preventDefault();
		// update the currentIndex
		currentIndex = (currentIndex + 1) % elements.length;
		// show the next element
		$(elements[currentIndex]).removeClass('hidden');
	});

	$('.remove-child-button').click(function (e) {
		e.preventDefault();
		var childId        = $(this).data('child-id');
		var currentWrapper = $('#childWrapper_' + childId);
		currentWrapper.addClass('hidden');
		// clear the input values
		currentWrapper.find('input').val('');
	});

	/**
	 * Toggle visibilty for second Partner
	 */
	$('#add-partner-button').click(function (e) {
		e.preventDefault();
		$('#second_marriage_partner_wrapper').removeClass('hidden');
		$('#add-partner-button').addClass('hidden');
	});

	$('.remove-partner-button').click(function (e) {
		e.preventDefault();
		var currentWrapper = $('#second_marriage_partner_wrapper');
		currentWrapper.addClass('hidden');
		currentWrapper.find('input').val('');
		$('#add-partner-button').removeClass('hidden');
	});

	//Check if Email or debtor number exists
	$('#new-user').on('submit', function (e) {
		e.preventDefault();

		var nonce               = $('#check_email_nonce').val();
		var userID              = $('#edit_user_id').val();
		var email               = $('#email').val();
		var currentEmail        = $('#email').data('email-old');
		var debtorNumber        = $('#debtor-number').val();
		var currentDebtorNumber = $('#debtor-number').data('debtor-number-old');
		var memberID            = $('#member-id').val();
		var currentMemberID     = $('#member-id').data('member-id-old');
		if (email != currentEmail || debtorNumber != currentDebtorNumber || memberID != currentMemberID) {

			$.ajax({
				url:     ajax_url,
				type:    'POST',
				data:    {
					action:            'check_email',
					check_email_nonce: nonce,
					user_id:           userID,
					email:             email,
					debtor_number:     debtorNumber,
					member_id:         memberID
				},
				success: function (response) {
					if (response.data.email == 'exists') {
						$('#email').prev().text('Diese E-Mail-Adresse existiert bereits!')
							.css('color', '#e11d48');
						$('#email').addClass('alert-danger');
						$('html, body').animate({
							scrollTop: $('#email').offset().top - 100
						}, 500);
						return false;
					}
					else if (response.data.debtor_number == 'exists') {
						$('#debtor-number').prev().text('Diese Debitorennummer existiert bereits!')
							.css('color', '#e11d48');
						$('#debtor-number').addClass('alert-danger');
						$('html, body').animate({
							scrollTop: $('#debtor-number').offset().top - 100
						}, 500);
						return false;
					}
					else if (response.data.member_id == 'exists') {
						$('#member-id').prev().text('Diese Mitgliedsnummer existiert bereits!')
							.css('color', '#e11d48');
						$('#member-id').addClass('alert-danger');
						$('html, body').animate({
							scrollTop: $('#member-id').offset().top - 100
						}, 500);
						return false;
					}
					else {
						$('#new-user').unbind('submit').submit();
					}
				}
			});

		}
		else {
			$('#new-user').unbind('submit').submit();
		}
	});

	/**
	 * Toggles the visibility of form elements.
	 */
	$('.form-toggler').on('change', function () {
		var toggleElementID = $(this).data('toggle-form-id');
		$('#' + toggleElementID).toggleClass('d-none');
	});

	/**
	 * Toggles other input elements if they are checked.
	 */
	$('.switch-toggler').on('click', function () {
		var isChecked     = $(this).prop('checked');
		var toggleInputID = $(this).attr('data-toggle-input-id');
		if ($('#' + toggleInputID).is(':checked')) {
			//$('#' + toggleInputID).click();
			$('#' + toggleInputID).prop('checked', false).trigger('change');
		}

		$(this).prop('checked', isChecked);
	});

	/**
	 * Toggles the 'active' state of buttons in button groups
	 */
	$('.btn-toggle-group').on('click', '.btn', function () {
		$(this).addClass('active').siblings().removeClass('active');
	});

	reInitCheckboxes();

	/**
	 * Wrap ajax-sort-table th elements with dataTable-sorter elements.
	 */
	$('.ajax-sort-table th').not('[data-sortable=\'false\']').wrapInner(function () {
		return '<a class=\'dataTable-sorter\'></a>';
	});

	/**
	 * Filters by form elements.
	 */
	function handleFilterFormEvent(event) {
		event.preventDefault();
		let currentInput = $(this);
		let filterForm   = $(this).parents('.filter-form');
		if (currentInput.hasClass('btn-export-filter-table')) {
			var filterFormID = currentInput.data('filter-form-id');
			filterForm       = $('#' + filterFormID);
		}
		let filterItems               = filterForm.find('.filter-items').val();
		let filterItemContainer       = filterForm.data('filter-item-container');
		let filterItemTableID         = filterForm.data('filter-item-table');
		let filterItemTablePagination = filterForm.data('filter-item-table-pagination');
		let currentButton             = filterForm.find('.filter-button');
		let resetButton               = filterForm.find('.reset-button');

		if (event.type == 'click' && (currentInput.prop('type') != 'button' && !currentInput.hasClass('dataTable-sorter'))) {
			return;
		}

		if (currentInput.hasClass('reset-button')) {
			filterForm.trigger('reset');
			resetButton.addClass('d-none');
		}

		if (currentInput.hasClass('dataTable-sorter')) {
			let sorterParent = $(this).parent();
			// Remove all TH tags with an "active" class
			if (filterForm.find('th').removeClass('active')) {
				// Set "active" class to the clicked TH tag
				sorterParent.addClass('active');
				filterForm.find('th').not('.active').removeClass('active').removeClass('desc').removeClass('asc');
			}
			if (!sorterParent.hasClass('asc')) {
				sorterParent.addClass('asc');
				if (sorterParent.hasClass('desc')) {
					sorterParent.removeClass('desc');
				}
			}
			else {
				sorterParent.removeClass('asc');
				if (!sorterParent.hasClass('desc')) {
					sorterParent.addClass('desc');
				}
			}
		}

		let nonce     = $('#filter_items_nonce').val();
		let form_data = getFilterFormFormData(filterForm, currentInput);

		//console.log('currentInputType: ', currentInput.prop('type'));
		//console.log('currentEventType: ', event.type);
		console.log('currentInputValue: ', currentInput.val());
		console.log('form_data: ', form_data);

		$.ajax({
			url:        ajax_url,
			type:       'POST',
			data:       {
				action:    'filter_items',
				nonce:     nonce,
				form_data: form_data
			},
			beforeSend: function (xhr) {
				//btnLoading(currentButton);
				if (filterItemTableID !== undefined) {
					$('#' + filterItemTableID).slideUp();
					if (allTables[filterItemTableID] !== undefined) {
						allTables[filterItemTableID].destroy();
					}
				}
				if (filterItemTablePagination !== undefined) {
					$('#' + filterItemTablePagination).slideUp();
				}
				$(loadingHTML).insertAfter('#' + filterItemTableID);

			},
			success:    function (response) {
				console.log('filter success: ', response);
				//btnReset(currentButton);
				$('#loading-html').remove();
				if (response.data.filtered_items != '') {
					$('#' + filterItemContainer).html(response.data.filtered_items);
				}
				if (resetButton !== undefined && !currentInput.hasClass('reset-button')) {
					resetButton.removeClass('d-none');
				}

				if (filterItemTablePagination !== undefined && response.data.table_pagination != '') {
					$('#' + filterItemTablePagination).html(response.data.table_pagination);
					$('#' + filterItemTablePagination).slideDown();
				}

				if (filterItemTableID !== undefined) {

					if (allTables[filterItemTableID] !== undefined) {
						storeTableCheckboxes(filterItemTableID);
						allTables[filterItemTableID].init();
						reInitCheckboxes();
					}
					if ($('#' + filterItemTableID).hasClass('ajax-sort-table')) {
						checkTableCheckboxes(filterItemTableID);
					}
					$('#' + filterItemTableID).slideDown();
				}

				//console.log('ajax allTablesCheckboxes[' + filterItemTableID + ']: ', allTablesCheckboxes[filterItemTableID]);

				if (response.data.csv !== undefined) {
					var downloadLink = document.createElement('a');
					var fileData     = ['\ufeff' + response.data.csv];

					var blobObject = new Blob(fileData, {
						type: 'text/csv;charset=utf-8;'
					});

					var url               = URL.createObjectURL(blobObject);
					downloadLink.href     = url;
					downloadLink.download = 'export.csv';
					if (currentInput.data('file-name') !== undefined) {
						downloadLink.download = currentInput.data('file-name');
					}

					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				}

				if (response.data.pdf !== undefined) {
					var downloadLink = document.createElement('a');
					var fileData     = [response.data.pdf];

					var blobObject = new Blob(fileData, {
						type: 'application/pdf'
					});

					var url               = URL.createObjectURL(blobObject);
					downloadLink.href     = url;
					downloadLink.download = 'export.pdf';
					if (currentInput.data('file-name') !== undefined) {
						downloadLink.download = currentInput.data('file-name');
					}

					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				}
			},
			error:      function (data) {
				console.log('error: ', data);
			}
		});
		return false;
	};

	$('body').on('change click', '.filter-form :input:not(:checkbox, .multi-select-action, .multi-do-action, .info-button), .filter-form .dataTable-sorter, .filter-form .delete-debtor, .btn-export-filter-table', handleFilterFormEvent);

	$('.filter-form	').on('keypress', function (e) {
		if (e.which == 13) {
			$(this).find('.filter-button').trigger('click');
			return false;
		}
	});

	function getFilterFormFormData(filterForm, currentInput) {
		let form_data = {};
		let form      = filterForm.serializeArray();
		let formID    = filterForm.attr('id');

		for (var i = 0; i < form.length; i++) {
			if (form[i]['name'].endsWith('[]')) {
				var name = form[i]['name'];
				name     = name.substring(0, name.length - 2);
				if (!(name in form_data)) {
					form_data[name] = [];
				}
				form_data[name].push(form[i]['value']);
			}
			else {
				form_data[form[i]['name']] = form[i]['value'];
			}
		}

		if (allFilterData[formID] != undefined) {
			for (const property in allFilterData[formID]) {
				console.log(property + ': ' + allFilterData[formID][property]);
				for (const filterItem in allFilterData[formID][property]) {
					form_data[filterItem] = (allFilterData[formID][property][filterItem]);
				}

			}
		}

		let thActive         = filterForm.find('th.active');
		let currentOrderBy   = thActive.data('order-by');
		let currentSortOrder = thActive.hasClass('desc') ? 'DESC' : 'ASC';
		let currentOrderType = thActive.data('order-type');

		if (currentOrderBy != undefined) {
			form_data['orderby'] = currentOrderBy;
			form_data['order']   = currentSortOrder;
		}

		if (currentOrderType != undefined) {
			form_data['ordertype'] = currentOrderType;
		}

		if (currentInput !== undefined && currentInput.hasClass('pager-link')) {
			form_data['paged'] = currentInput.data('page');
			console.log('paged: ', currentInput.data('page'));
		}
		else if (filterForm.find('.pager.active')) {
			form_data['paged'] = filterForm.find('.pager.active button').data('page');
			console.log('paged: ', currentInput.data('page'));
		}
		if (currentInput.is('.form-control, .form-select, .reset-button')) {
			form_data['paged'] = 1;
			console.log('paged: ', 1);
		}

		if (currentInput !== undefined && currentInput.hasClass('btn-export-filter-table')) {
			if (currentInput.attr('data-file-type') === 'csv') {
				form_data['export_csv'] = 'true';
				let tableHead           = filterForm.find('thead').html();
				form_data['table_head'] = JSON.stringify(tableHead);
				console.log('currentInput: export_csv');
			}
			if (currentInput.attr('data-file-type') === 'pdf') {
				form_data['export_pdf'] = 'true';
				console.log('currentInput: export_pdf');
			}
		}

		return form_data;
	}

	/**
	 * Call the main download file function.
	 */
	$(document).on('click', '.download-file-button', function (event) {
		event.preventDefault();
		let currentButton = $(this);
		let parentModal   = currentButton.parents('.modal');
		let itemID        = currentButton.data('item-id');
		let itemType      = currentButton.data('item-type');
		let reloadURL     = currentButton.data('reload-url');
		let nonce         = $('#download_file_nonce').val();
		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:    'download_file',
				nonce:     nonce,
				item_id:   itemID,
				item_type: itemType
			},
			success: function (response) {
				if (response.success === true) {
					console.log('response: ', response);
					if (response.data.csv !== undefined) {
						var downloadLink = document.createElement('a');
						var fileData     = ['\ufeff' + response.data.csv];

						var blobObject = new Blob(fileData, {
							type: 'text/csv;charset=utf-8;'
						});

						var url               = URL.createObjectURL(blobObject);
						downloadLink.href     = url;
						downloadLink.download = 'export.csv';
						if (currentButton.data('file-name') !== undefined) {
							downloadLink.download = currentButton.data('file-name');
						}

						document.body.appendChild(downloadLink);
						downloadLink.click();
						document.body.removeChild(downloadLink);
					}
					if (parentModal !== undefined) {
						parentModal.modal('hide');
					}
					if (reloadURL !== undefined) {
						location.replace(reloadURL);
					}

				}
				else {
					console.log('error: ', response);
				}
			}
		});
		return false;
	});

	/**
	 * Modifies the .info-modal modals.
	 */
	$('.info-modal').on('show.bs.modal', function (event) {
		var modal         = $(this);
		var button        = $(event.relatedTarget);
		var itemID        = button.data('item-id');
		var itemType      = button.data('item-type');
		var noItemText    = button.data('no-item-text');
		var modalTitle    = button.data('modal-title');
		var modalItemName = button.data('modal-item-name');
		var modalInfo     = modal.find('.modal-info');
		var actionButton  = modal.find('.main-action-button');
		let nonce         = $('#get_item_info_nonce').val();

		if (itemID !== undefined) {
			actionButton.attr('data-item-id', itemID);
			console.log('itemID: ' + itemID);
		}
		if (itemType !== undefined) {
			actionButton.attr('data-item-type', itemType);
			console.log('itemType: ' + itemType);
		}
		if (noItemText !== undefined) {
			actionButton.attr('data-no-item-text', noItemText);
			console.log('noItemText: ' + noItemText);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').html(modalTitle);
		}
		if (modalItemName !== undefined) {
			modal.find('.modal-item-name').text(modalItemName);
		}

		$.ajax({
			url:        ajax_url,
			type:       'POST',
			data:       {
				action:    'get_item_info',
				nonce:     nonce,
				item_id:   itemID,
				item_type: itemType
			},
			beforeSend: function (xhr) {
				modalInfo.slideUp();
				$(loadingHTML).insertAfter(modalInfo);
			},
			success:    function (data) {
				$('#loading-html').remove();
				modalInfo.html(data);
				modalInfo.slideDown();
				if (itemType == 'order_items_credit_statement') {
					console.log("attachEventListenersForCreditCalculation");
					attachEventListenersForCreditCalculation();
				}

			},
			error:      function (data) {
				console.log(data);
			}
		});
	});

	function attachEventListenersForCreditCalculation() {
		console.log('attaching event listeners for credit calculation...');
		$('.credit-item-input').on('change', function() {
			console.log('calculating credit sum...');
			calculateCreditSum();
		});
	}
	
	// Function to calculate the total credit sum
	function calculateCreditSum() {
		let totalSum = 0;
	
		$('.credit-item-input').each(function() {
			let quantity = parseFloat($(this).val());
			let price = parseFloat($(this).data('price'));
	
			if (!isNaN(quantity) && !isNaN(price)) {
				totalSum += quantity * price;
			}
		});
	
		$('#credit-sum').text(totalSum.toFixed(2) + ' €');
	}

	$(document).on('click', '.main-delete-items-button', function () {
		let items          = [];
		let currentButton  = $(this);
		let parentModal    = $(this).parents('.modal');
		let itemID         = $(this).data('item-id');
		let itemIDs        = $(this).data('item-ids');
		let reloadURL      = $(this).data('reload-url');
		let itemType       = $(this).data('item-type');
		let itemsContainer = $(this).data('items-container');
		let itemsTableID   = $(this).data('items-table');
		let nonce          = $('#delete_items_nonce').val();

		let URLString = '';

		if (itemID !== undefined && itemID !== '') {
			items.push(itemID);
			URLString = '?deleted=true';
		}
		else if (itemIDs !== undefined) {
			items     = itemIDs.split(',');
			URLString = '?deleted_multiple=true';
		}
		var itemsLength = items.length;

		console.log('items: ', items);
		console.log('itemType: ', itemType);

		$.ajax({
			url:        ajax_url,
			type:       'POST',
			data:       {
				action:    'delete_items',
				nonce:     nonce,
				items:     items,
				item_type: itemType
			},
			beforeSend: function (xhr) {
				btnDeleting(currentButton);
				if (itemsTableID !== '') {
					console.log('itemsTableID: ', itemsTableID);
					$('#' + itemsTableID).slideUp();
					allTables[itemsTableID].destroy();
					$(loadingHTML).insertAfter('#' + itemsTableID);
				}
			},
			success:    function (data) {
				console.log('success: ', data);
				btnReset(currentButton);
				if (data.success_msg) {
					console.log('success: ', data.success_msg);
				}
				else {
					$('#loading-html').remove();
					if (itemsContainer !== '') {
						$('#' + itemsContainer).html(data);
					}
					if (itemsTableID !== '') {
						storeTableCheckboxes(itemsTableID);
						allTables[itemsTableID].init();
						$('#' + itemsTableID).slideDown();
					}

					reInitCheckboxes();
				}

				setTimeout(function () {
					parentModal.modal('hide');

					if (reloadURL !== undefined) {
						//console.log('reloadURL: '+ reloadURL + URLString);
						location.replace(reloadURL + URLString);
					}
				}, 1000);
			},
			error:      function (data) {
				console.log(data);
			}
		});
		return false;
	});

	/**
	 * Changes the target modal of .multi-do-action button
	 */
	$('.multi-select-action').change(function () {
		var selectedOption = $(this).find(':selected');
		var actionButton   = $(this).next('.multi-do-action');

		var modalID        = selectedOption.data('modal-change');
		var modalTitle     = selectedOption.data('modal-title');
		var modalItemName  = selectedOption.data('modal-item-name');
		var modalReloadURL = selectedOption.data('reload-url');

		if (modalID !== undefined) {
			actionButton.attr('data-bs-target', '#' + modalID);
		}
		if (modalTitle !== undefined) {
			actionButton.attr('data-modal-title', modalTitle);
		}
		if (modalItemName !== undefined) {
			actionButton.attr('data-modal-item-name', modalItemName);
		}
		if (modalReloadURL !== undefined) {
			actionButton.attr('data-reload-url', modalReloadURL);
		}
	});

	$('.multi-do-action').click(function (e) {
		e.preventDefault();
	});

	/**
	 * Modifies the .main-modal modals.
	 */
	$('.main-modal').on('show.bs.modal', function (event) {
		var modal          = $(this);
		var button         = $(event.relatedTarget);
		var itemID         = button.data('item-id');
		var itemType       = button.data('item-type');
		var itemStatus     = button.data('item-status');
		var noItemText     = button.data('no-item-text');
		var modalTitle     = button.data('modal-title');
		var modalItemName  = button.data('modal-item-name');
		var reloadURL      = button.data('reload-url');
		var checkItemsWrap = button.data('check-items-wrap');
		var actionButton   = modal.find('.main-action-button');

		if (itemID !== undefined) {
			actionButton.attr('data-item-id', itemID);
			console.log('itemID: ' + itemID);
		}
		if (itemType !== undefined) {
			actionButton.attr('data-item-type', itemType);
			console.log('itemType: ' + itemType);
		}
		if (itemStatus !== undefined) {
			actionButton.attr('data-item-status', itemStatus);
			modal.find('.modal-item-status').val(itemStatus);
			console.log('itemStatus: ' + itemStatus);
		}
		if (noItemText !== undefined) {
			actionButton.attr('data-no-item-text', noItemText);
			console.log('noItemText: ' + noItemText);
		}
		if (reloadURL !== undefined) {
			actionButton.attr('data-reload-url', reloadURL);
			console.log('reloadURL: ' + reloadURL);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').html(modalTitle);
		}
		if (modalItemName !== undefined) {
			modal.find('.modal-item-name').html(modalItemName);
		}
		if (checkItemsWrap !== undefined) {
			var selectedIDs = [];
			var ul          = $('<ul>', {'class': 'item-ul m-0'});
			$(modal.find('.item-ul')).remove();
			if (allTablesCheckboxes[checkItemsWrap] !== undefined) {
				for (key in allTablesCheckboxes[checkItemsWrap]) {
					if (allTablesCheckboxes[checkItemsWrap][key]['checked']) {
						var id   = allTablesCheckboxes[checkItemsWrap][key]['id'];
						var name = allTablesCheckboxes[checkItemsWrap][key]['name'];
						var li   = $('<li>').attr('data-item-id', id).html(name);
						selectedIDs.push(id);
						ul.append(li);
					}
				}
			}
			else {
				$('#' + checkItemsWrap).find('input:checked:not(.table-check-toggler)').each(function () {
					var id   = $(this).data('id');
					var name = $(this).data('name');
					var li   = $('<li>').attr('data-item-id', id).html(name);
					selectedIDs.push(id);
					ul.append(li);
				});
			}
			console.log('selectedIDs: ', selectedIDs);
			if (selectedIDs.length === 0) {
				actionButton.addClass('d-none');
				if (noItemText !== undefined) {
					modal.find('.modal-info').addClass('d-none');
					//modal.find('.modal-item-name').html('<i class="fa fa-exclamation-triangle me-1"></i>' + noItemText);
					let noItemHtml = '<div class="alert alert-warning d-flex align-items-center modal-no-item-info"><i class="fa fa-exclamation-triangle me-1"></i>' + noItemText + '</div>';
					$(noItemHtml).insertAfter(modal.find('.modal-info'));
				}
				modal.find('.modal-form').addClass('d-none');
			}
			else {
				actionButton.removeClass('d-none');
				modal.find('.modal-info').removeClass('d-none');
				$(modal.find('.modal-no-item-info')).remove();
				modal.find('.modal-form').removeClass('d-none');
				if (selectedIDs.length === 1) {
					actionButton.attr('data-item-id', selectedIDs);
				}
				else {
					actionButton.attr('data-item-ids', selectedIDs);
				}
			}

			modal.find('.item-list').append(ul);
		}
	});

	/**
	 * Call the main delete post function.
	 */
	$(document).on('click', '#main-delete-post-button', function () {
		let deleteItems   = [];
		let parentModal   = $(this).parents('.modal');
		let deleteItemID  = $(this).data('item-id');
		let deleteItemIDs = $(this).data('item-ids');
		let itemType      = $(this).data('item-type');
		let reloadURL     = $(this).data('reload-url');
		let nonce         = $('#delete_post_nonce').val();
		let URLString     = '';

		if (deleteItemID !== undefined && deleteItemID !== '') {
			deleteItems.push(deleteItemID);
			URLString = '/?deleted=true';
		}
		else if (deleteItemIDs !== undefined) {
			deleteItems = deleteItemIDs.split(',');
			URLString   = '/?deleted_multiple=true';
		}
		var deleteItemsLength = deleteItems.length;
		var i                 = 0;

		console.log('deleteItems: ', deleteItems);

		function process(i) {
			console.log('deleteItems[i]: ', deleteItems[i]);
			$.post(
				ajax_url,
				{
					action:            'delete_post',
					delete_post_nonce: nonce,
					current_post_id:   deleteItems[i],
					current_post_type: itemType
				}
			).done(function (result) {
				if (result.success === true) {
					//console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					//console.log('deletedItems: ' + i);

					$('  <span class="text-success">  <i class="fa fa-check-circle"></i> Gelöscht</span>').appendTo(parentModal.find($('li[data-item-id=\'' + deleteItems[i] + '\']')));

					if (i === (deleteItems.length - 1)) {

						parentModal.find('.modal-info').removeClass('alert-info').addClass('alert-success');

						setTimeout(function () {
							parentModal.modal('hide');

							if (reloadURL !== undefined) {
								location.replace(reloadURL + URLString);
							}
							else {
								location.reload(true);
							}
						}, 2000);
					}

				}
				else {
					console.log('error: ', result);
					$('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(parentModal.find($('li[data-item-id=\'' + deleteItems[i] + '\']')));
				}
				if (i++ < (deleteItems.length - 1)) {
					process(i);
				}
			});

		}

		process(0);
		return false;
	});

	/**
	 * Modifies the main delete term modal.
	 */
	$('#modal-delete-term').on('show.bs.modal', function (event) {
		var button             = $(event.relatedTarget);
		var deleteTermID       = button.data('delete-term-id');
		var deleteTermTaxonomy = button.data('delete-term-taxonomy');
		var deleteTermChildren = button.data('delete-term-children');
		var modalTitle         = button.data('modal-title');
		var deleteTermName     = button.data('delete-term-name');
		var reloadURL          = button.data('reload-url');

		var modal = $(this);
		if (deleteTermID !== undefined) {
			$('#main-delete-term-button').attr('data-delete-term-id', deleteTermID);
			console.log('deleteTermID: ' + deleteTermID);
		}
		if (deleteTermTaxonomy !== undefined) {
			$('#main-delete-term-button').attr('data-delete-term-taxonomy', deleteTermTaxonomy);
			console.log('deleteTermTaxonomy: ' + deleteTermTaxonomy);
		}
		if (deleteTermChildren !== undefined) {
			$('#main-delete-term-button').attr('data-delete-term-children', deleteTermChildren);
			console.log('deleteTermChildren: ' + deleteTermChildren);
		}
		if (reloadURL !== undefined) {
			$('#main-delete-term-button').attr('data-reload-url', reloadURL);
			console.log('reloadURL: ' + reloadURL);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').text(modalTitle);
		}
		if (deleteTermName !== undefined) {
			modal.find('#delete-term-name').text(deleteTermName);
		}
	});

	/**
	 * Call the main delete term function.
	 */
	$(document).on('click', '#main-delete-term-button', function () {
		let parentModal        = $(this).parents('.modal');
		let deleteTermID       = $(this).data('delete-term-id');
		let deleteTermTaxonomy = $(this).data('delete-term-taxonomy');
		let deleteTermChildren = $(this).data('delete-term-children');
		let reloadURL          = $(this).data('reload-url');
		let nonce              = $('#delete_term_nonce').val();
		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:                       'delete_term',
				delete_term_nonce:            nonce,
				current_term_id:              deleteTermID,
				current_term_taxonomy:        deleteTermTaxonomy,
				current_term_delete_children: deleteTermChildren
			},
			success: function (result) {
				if (result.success === true) {
					console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					parentModal.modal('hide');

					if (reloadURL !== undefined) {
						location.replace(reloadURL + '/?deleted=true');
					}
					else {
						location.reload(true);
					}

				}
				else {
					console.log('error: ', result);
				}
			}
		});
		return false;
	});

	/**
	 * Modifies the main delete file modal.
	 */
	$('#modal-delete-file').on('show.bs.modal', function (event) {
		var button         = $(event.relatedTarget);
		var deleteFileID   = button.data('delete-file-id');
		var modalTitle     = button.data('modal-title');
		var deleteFileName = button.data('delete-file-name');
		var reloadURL      = button.data('reload-url');

		var modal = $(this);
		if (deleteFileID !== undefined) {
			$('#main-delete-file-button').attr('data-delete-file-id', deleteFileID);
			console.log('deleteFileID: ' + deleteFileID);
		}
		if (reloadURL !== undefined) {
			$('#main-delete-file-button').attr('data-reload-url', reloadURL);
			console.log('reloadURL: ' + reloadURL);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').text(modalTitle);
		}
		if (deleteFileName !== undefined) {
			modal.find('#delete-file-name').text(deleteFileName);
		}
	});

	/**
	 * Call the main delete file function.
	 */
	$(document).on('click', '#main-delete-file-button', function () {
		let parentModal  = $(this).parents('.modal');
		let deleteFileID = $(this).data('delete-file-id');
		let reloadURL    = $(this).data('reload-url');
		let nonce        = $('#delete_file_nonce').val();
		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:            'delete_file',
				delete_file_nonce: nonce,
				current_file_id:   deleteFileID
			},
			success: function (result) {
				if (result.success === true) {
					console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					parentModal.modal('hide');

					if (reloadURL !== undefined) {
						location.replace(reloadURL + '/?deleted=true');
					}
					else {
						location.reload(true);
					}

				}
				else {
					console.log('error: ', result);
				}
			}
		});
		return false;
	});

	/**
	 * Call the main delete user function.
	 */
	$(document).on('click', '#main-delete-user-button', function () {
		let deleteItems   = [];
		let parentModal   = $(this).parents('.modal');
		let deleteItemID  = $(this).data('item-id');
		let deleteItemIDs = $(this).data('item-ids');
		let reloadURL     = $(this).data('reload-url');
		let nonce         = $('#delete_user_nonce').val();
		let URLString     = '';

		if (deleteItemID !== undefined && deleteItemID !== '') {
			deleteItems.push(deleteItemID);
			URLString = '/?deleted=true';
		}
		else if (deleteItemIDs !== undefined) {
			deleteItems = deleteItemIDs.split(',');
			URLString   = '/?deleted_multiple=true';
		}
		var deleteItemsLength = deleteItems.length;
		var i                 = 0;

		console.log('deleteItems: ', deleteItems);

		function process(i) {
			console.log('deleteItems[i]: ', deleteItems[i]);
			$.post(
				ajax_url,
				{
					action:            'delete_user',
					delete_user_nonce: nonce,
					current_user_id:   deleteItems[i]
				}
			).done(function (result) {
				if (result.success === true) {
					//console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					//console.log('deletedItems: ' + i);

					$('  <span class="text-success">  <i class="fa fa-check-circle"></i> Gelöscht</span>').appendTo(parentModal.find($('li[data-item-id=\'' + deleteItems[i] + '\']')));

					if (i === (deleteItems.length - 1)) {

						parentModal.find('.modal-info').removeClass('alert-info').addClass('alert-success');

						setTimeout(function () {
							parentModal.modal('hide');

							if (reloadURL !== undefined) {
								location.replace(reloadURL + URLString);
							}
							else {
								location.reload(true);
							}
						}, 2000);
					}

				}
				else {
					console.log('error: ', result);
					$('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(parentModal.find($('li[data-item-id=\'' + deleteItems[i] + '\']')));
				}
				if (i++ < (deleteItems.length - 1)) {
					process(i);
				}
			});

		}

		process(0);
		return false;
	});

	/**
	 * Modifies the main edit term modal.
	 */
	$('#modal-edit-term').on('show.bs.modal', function (event) {
		var button           = $(event.relatedTarget);
		var editTermID       = button.data('edit-term-id');
		var editTermTaxonomy = button.data('edit-term-taxonomy');
		var modalTitle       = button.data('modal-title');
		var editTermName     = button.data('edit-term-name');
		var editTermDesc     = button.data('edit-term-desc');
		var editTermNum      = button.data('edit-term-num');
		var reloadURL        = button.data('reload-url');

		var modal = $(this);
		if (editTermID !== undefined) {
			$('#main-edit-term-button').attr('data-edit-term-id', editTermID);
			console.log('editTermID: ' + editTermID);
		}
		if (editTermTaxonomy !== undefined) {
			$('#main-edit-term-button').attr('data-edit-term-taxonomy', editTermTaxonomy);
			console.log('editTermTaxonomy: ' + editTermTaxonomy);
		}
		if (reloadURL !== undefined) {
			$('#main-edit-term-button').attr('data-reload-url', reloadURL);
			console.log('reloadURL: ' + reloadURL);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').text(modalTitle);
		}
		if (editTermName !== undefined) {
			modal.find('#edit-term-name').val(editTermName);
		}
		if (editTermDesc !== undefined) {
			modal.find('#edit-term-desc-row').removeClass('d-none');
			modal.find('#edit-term-desc').val(editTermDesc);
		}
		else {
			modal.find('#edit-term-desc-row').addClass('d-none');
		}
		if (editTermNum !== undefined) {
			modal.find('#edit-term-num-row').removeClass('d-none');
			modal.find('#edit-term-num').val(editTermNum);
		}
		else {
			modal.find('#edit-term-num-row').addClass('d-none');
		}
	});

	/**
	 * Call the main edit term function.
	 */
	$(document).on('click', '#main-edit-term-button', function () {
		let parentModal      = $(this).parents('.modal');
		let editTermID       = $(this).data('edit-term-id');
		let editTermTaxonomy = $(this).data('edit-term-taxonomy');
		let reloadURL        = $(this).data('reload-url');
		let nonce            = $('#edit_term_nonce').val();
		let editTermName     = parentModal.find('#edit-term-name').val();
		let editTermDesc     = parentModal.find('#edit-term-desc').val();
		let editTermNum      = parentModal.find('#edit-term-num').val();
		console.log('editTermName: ' + editTermName);

		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:                 'edit_term',
				edit_term_nonce:        nonce,
				current_term_id:        editTermID,
				current_term_taxonomy:  editTermTaxonomy,
				current_term_edit_name: editTermName,
				current_term_edit_desc: editTermDesc,
				current_term_edit_num:  editTermNum
			},
			success: function (result) {
				if (result.success === true) {
					console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					parentModal.modal('hide');

					if (reloadURL !== undefined) {
						location.replace(reloadURL + '/?edited=true');
					}
					else {
						location.reload(true);
					}

				}
				else {
					console.log('error: ', result);
				}
			}
		});
		return false;
	});

	/**
	 * Modifies the main duplicate term modal.
	 */
	$('#modal-duplicate-term').on('show.bs.modal', function (event) {
		var button                = $(event.relatedTarget);
		var duplicateTermID       = button.data('duplicate-term-id');
		var duplicateTermTaxonomy = button.data('duplicate-term-taxonomy');
		var duplicateTermChildren = button.data('duplicate-term-children');
		var modalTitle            = button.data('modal-title');
		var duplicateTermName     = button.data('duplicate-term-name');
		var reloadURL             = button.data('reload-url');

		var modal = $(this);
		if (duplicateTermID !== undefined) {
			$('#main-duplicate-term-button').attr('data-duplicate-term-id', duplicateTermID);
			console.log('duplicateTermID: ' + duplicateTermID);
		}
		if (duplicateTermTaxonomy !== undefined) {
			$('#main-duplicate-term-button').attr('data-duplicate-term-taxonomy', duplicateTermTaxonomy);
			console.log('duplicateTermTaxonomy: ' + duplicateTermTaxonomy);
		}
		if (duplicateTermChildren !== undefined) {
			$('#main-duplicate-term-button').attr('data-duplicate-term-children', duplicateTermChildren);
			console.log('duplicateTermChildren: ' + duplicateTermChildren);
		}
		if (reloadURL !== undefined) {
			$('#main-duplicate-term-button').attr('data-reload-url', reloadURL);
			console.log('reloadURL: ' + reloadURL);
		}
		if (modalTitle !== undefined) {
			modal.find('.modal-title').text(modalTitle);
		}
		if (duplicateTermName !== undefined) {
			modal.find('#duplicate-term-name').val(duplicateTermName + ' [Duplikat]');
		}
	});

	/**
	 * Call the main duplicate term function.
	 */
	$(document).on('click', '#main-duplicate-term-button', function () {
		let parentModal           = $(this).parents('.modal');
		let duplicateTermID       = $(this).data('duplicate-term-id');
		let duplicateTermTaxonomy = $(this).data('duplicate-term-taxonomy');
		let duplicateTermChildren = $(this).data('duplicate-term-children');
		let reloadURL             = $(this).data('reload-url');
		let nonce                 = $('#duplicate_term_nonce').val();
		let duplicateTermName     = parentModal.find('#duplicate-term-name').val();
		console.log('duplicateTermName: ' + duplicateTermName);

		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:                          'duplicate_term',
				duplicate_term_nonce:            nonce,
				current_term_id:                 duplicateTermID,
				current_term_taxonomy:           duplicateTermTaxonomy,
				current_term_duplicate_children: duplicateTermChildren,
				current_term_duplicate_name:     duplicateTermName
			},
			success: function (result) {
				if (result.success === true) {
					console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					parentModal.modal('hide');

					if (reloadURL !== undefined) {
						location.replace(reloadURL + '/?duplicated=true');
					}
					else {
						location.reload(true);
					}

				}
				else {
					console.log('error: ', result);
				}
			}
		});
		return false;
	});

	/**
	 * Call the main duplicate post function.
	 */
	$(document).on('click', '.duplicate-post-button', function () {

		let duplicatePostID   = $(this).data('duplicate-post-id');
		let duplicatePostType = $(this).data('duplicate-post-type');
		let reloadURL         = $(this).data('reload-url');
		let nonce             = $('#duplicate_post_nonce').val();

		$.ajax({
			url:     ajax_url,
			type:    'POST',
			data:    {
				action:               'duplicate_post',
				duplicate_post_nonce: nonce,
				current_post_id:      duplicatePostID,
				post:                 duplicatePostID,
				current_post_type:    duplicatePostType
			},
			success: function (result) {
				if (result.success === true) {
					console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);

					if (reloadURL !== undefined) {
						location.replace(reloadURL + '/?duplicated=true');
					}
					else {
						location.reload(true);
					}

				}
				else {
					console.log('error: ', result);
				}
			},
			error:   function (err) {
				console.log(err);
			}
		});
		return false;
	});

	/**
	 * Call the main send mail function.
	 */
	$(document).on('click', '#main-send-mail-button', function () {
		let sendItems       = [];
		let currentButton   = $(this);
		let parentModal     = $(this).parents('.modal');
		let sendItemID      = $(this).data('item-id');
		let sendItemIDs     = $(this).data('item-ids');
		let reloadURL       = $(this).data('reload-url');
		let nonce           = $('#send_mail_nonce').val();
		let sendMailSubject = $('#send-mail-subject').val();
		//let sendMailContent = $('#send_mail_content').html();
		let sendMailContent = tinymce.get('send_mail_content').getContent();
		let URLString       = '';

		if (sendItemID !== undefined && sendItemID !== '') {
			sendItems.push(sendItemID);
			URLString = '/?sended=true';
		}
		else if (sendItemIDs !== undefined) {
			sendItems = sendItemIDs.split(',');
			URLString = '/?sended_multiple=true';
		}
		var sendItemsLength = sendItems.length;
		var i               = 0;

		console.log('sendItems: ', sendItems);

		btnSending(currentButton);

		function process(i) {
			console.log('sendItems[i]: ', sendItems[i]);
			$.post(
				ajax_url,
				{
					action:               'send_mail',
					send_mail_nonce:      nonce,
					send_mail_subject:    sendMailSubject,
					send_mail_content:    sendMailContent,
					current_recipient_id: sendItems[i]
				}
			).done(function (result) {
				if (result.success === true) {
					//console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					//console.log('senddItems: ' + i);

					$('  <span class="text-success">  <i class="fa fa-check-circle"></i> gesendet</span>').appendTo(parentModal.find($('li[data-item-id=\'' + sendItems[i] + '\']')));

				}
				else {
					console.log('error: ', result);
					var errorMSG = '';
					if (result.data.error_msg !== '') {
						errorMSG = result.data.error_msg;
					}
					$('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler' + errorMSG + '</span>').appendTo(parentModal.find($('li[data-item-id=\'' + sendItems[i] + '\']')));
				}

				if (i === (sendItems.length - 1)) {
					btnReset(currentButton);
					parentModal.find('.modal-info').removeClass('alert-info').addClass('alert-success');

					setTimeout(function () {
						parentModal.modal('hide');

						if (reloadURL !== undefined) {
							location.replace(reloadURL + URLString);
						}
						else {
							//location.reload(true);
						}
					}, 2000);
				}
				if (i++ < (sendItems.length - 1)) {
					process(i);
				}
			});

		}

		process(0);
		return false;
	});

	/**
	 * Call the main edit user function.
	 */
	$(document).on('click', '#main-edit-user-button', function () {
		let items         = [];
		let currentButton = $(this);
		let parentModal   = $(this).parents('.modal');
		let itemID        = $(this).data('item-id');
		let itemIDs       = $(this).data('item-ids');
		let reloadURL     = $(this).data('reload-url');
		let itemType      = $(this).data('item-type');
		let nonce         = $('#edit_user_nonce').val();
		let form_data     = {};
		let form          = parentModal.find('.modal-form').serializeArray();

		for (var i = 0; i < form.length; i++) {
			if (form[i]['name'].endsWith('[]')) {
				var name = form[i]['name'];
				name     = name.substring(0, name.length - 2);
				if (!(name in form_data)) {
					form_data[name] = [];
				}
				form_data[name].push(form[i]['value']);
			}
			else {
				form_data[form[i]['name']] = form[i]['value'];
			}
		}

		let URLString = '';

		if (itemID !== undefined && itemID !== '') {
			items.push(itemID);
			URLString = '/?edited=true';
		}
		else if (itemIDs !== undefined) {
			items     = itemIDs.split(',');
			URLString = '/?edited_multiple=true';
		}
		var itemsLength = items.length;
		var i           = 0;

		console.log('items: ', items);
		console.log('itemType: ', itemType);
		console.log('form_data: ', form_data);

		btnSaving(currentButton);

		function process(i) {
			console.log('items[i]: ', items[i]);
			$.post(
				ajax_url,
				{
					action:            'edit_user',
					edit_user_nonce:   nonce,
					form_data:         form_data,
					current_user_id:   items[i],
					current_user_role: itemType
				}
			).done(function (result) {
				if (result.success === true) {
					//console.log('result: ', result);
					console.log('success_msg: ' + result.data.success_msg);
					//console.log('editdItems: ' + i);

					$('  <span class="text-success">  <i class="fa fa-check-circle"></i> gespeichert</span>').appendTo(parentModal.find($('li[data-item-id=\'' + items[i] + '\']')));

					if (i === (items.length - 1)) {
						btnReset(currentButton);

						parentModal.find('.modal-info').removeClass('alert-info').addClass('alert-success');

						setTimeout(function () {
							parentModal.modal('hide');

							if (reloadURL !== undefined) {
								location.replace(reloadURL + URLString);
							}
							else {
								//location.reload(true);
							}
						}, 2000);
					}

				}
				else {
					console.log('error: ', result);
					$('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(parentModal.find($('li[data-item-id=\'' + items[i] + '\']')));
				}
				if (i++ < (items.length - 1)) {
					process(i);
				}
			});

		}

		process(0);
		return false;
	});

});